import { render } from "./NotificationIcon.vue?vue&type=template&id=30bd309d"
const script = {}
script.render = render

export default script